var map = {
	"./balance-sign.png.webp": "WDd+",
	"./balance-sign.webp": "3dvn",
	"./contact.webp": "zRKo",
	"./content-bg.webp": "lOW3",
	"./display_off.webp": "mcWs",
	"./display_on.webp": "B8q8",
	"./electron1.webp": "zjxc",
	"./fishGame1.webp": "4MGe",
	"./fishGame2.webp": "9Y8d",
	"./fishGame3.webp": "2lOt",
	"./fishGame4.webp": "5MYu",
	"./float-help.webp": "e9Bo",
	"./float-line.webp": "nf8B",
	"./float-notice.webp": "yQme",
	"./float-phone.webp": "/Rj9",
	"./float-service.webp": "YSUX",
	"./hotGame.webp": "xAZW",
	"./label-bg.webp": "NOSN",
	"./left-bar-bg.webp": "JGty",
	"./logo.webp": "M2P7",
	"./logo2.webp": "7Two",
	"./lottery-nav-bg.webp": "IDOg",
	"./lottery-nav-item-active.webp": "lsLZ",
	"./lottery-nav-item.webp": "vw8N",
	"./lottery-sub-item-base.webp": "yy/r",
	"./member.webp": "DSpF",
	"./peopleGame1.webp": "YKpF",
	"./peopleGame2.webp": "SGUi",
	"./peopleGame3.webp": "h0OJ",
	"./peopleGame4.webp": "BS0g",
	"./proxy.webp": "K4OU",
	"./ptGame1.webp": "/AqT",
	"./ptGame2.webp": "9BWH",
	"./ptGame3.webp": "4e6r",
	"./ptGame4.webp": "VFz9",
	"./ptGame5.webp": "VYCN",
	"./ptGame6.webp": "XtDL",
	"./qpGame1.webp": "3eoe",
	"./reset.webp": "otOa",
	"./right-bar-bg.webp": "FaPn",
	"./speaker-container.webp": "+UAm",
	"./speaker.webp": "ny07",
	"./sportGame1.webp": "UYXk",
	"./sportGame2.webp": "Xbs0",
	"./sportGame3.webp": "T9vd",
	"./sportGame4.webp": "xy5H",
	"./user_admin.webp": "gJQi",
	"./user_cash.webp": "Kj76",
	"./user_exit.webp": "D7J0",
	"./user_recharge.webp": "aJ4Y",
	"./user_transfer.webp": "blcf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6sLk";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head ^\.\/.*\.webp$
// module id = 6sLk
// module chunks = 3